module.exports = __webpack_public_path__ + "static/position-31a121fb5c6939b399ba33fb35101aed.png";